import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=e02a601c&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=e02a601c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02a601c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
